<template>
  <el-row type="flex" justify="space-between" class="font-white font-bold">
    <el-col :span="18">
      <div class="title-label">
				<el-image :src="getOrgLogo" style="height: 40px;width: 40px;vertical-align: middle;margin-right: 10px;" fit="contain">
				</el-image>
				{{org.name}}
			</div>
    </el-col>
    <el-col :span="6">
			<div class="username-label">{{userInfo.name}}
				<div  @click="logOutHandler" style="display: inline-block;">
					<el-link style="margin-left: 10px;font-size: 12px;text-decoration: underline;color: #F23946;"> 退出登录</el-link>
				</div>

			</div>
		</el-col>
  </el-row>
</template>
<script>
	import config from "../../config/global.js";

	var logoutUrl = config.host+"/backend/signout";

    export default {
        components: {
				},
				computed:{
					userInfo:function () {
						return this.$store.getters.getUserInfo;
					},
					getOrgLogo:function () {
						if(this.org.logo == null )
							return "";
						return this.org.logo;
					}
				},
        data:function(){
            return {
							loading:false
            }
        },
			  props:{
					org:{}
				},
        methods: {
            logout(){
                this.$router.push('/login');
            },
            toIndex(){
            		this.$router.push('/index');
						},
						logOutHandler:function () {
							if(this.loading == false ){
								this.loading = true;
								this.$http.get(logoutUrl,{}).then(
									function(response){
										var res = response.body;
										this.$store.commit("cleanUserInfo");
										this.$router.replace({name:"login"});
										if(res.result!=1){
											this.$message.error(res.emsg);
										}
										this.loading=false;
									},function(){
										// this.$message.error("登出失败");
										this.$store.commit("cleanUserInfo");
										this.$router.replace({name:"login"});
										this.loading=false;
									})
							}
						}
        },
        watch:{
        }
    }
</script>
<style scoped>
  .title-label{
		font-size: 20px;
		line-height:60px;
	}

	.username-label{
		font-size: 18px;
		line-height:60px;
		display: inline-block;
		text-align: right;
		width: 100%;
	}

	.logout-btn{
		padding: 10px 20px;
		font-size: 18px;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/Header.vue